import api from 'Cloud/Application/api';
import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';
import { apiMigrateWeblinksV2ToV4 } from 'reactApp/appHelpers/featuresHelpers';
import { promisifyDeferredCall } from 'reactApp/utils/helpers';

const method = 'weblinks/domestic';

class WeblinksDomesticOffAPIV4Call extends APICallV4 {
    _method = method;
    _type: Method = 'post';
}

export const weblinksDomesticOffApiCall = (params: Record<string, any>): Promise<unknown> => {
    if (apiMigrateWeblinksV2ToV4.domestic) {
        return new WeblinksDomesticOffAPIV4Call().makeRequest({
            weblink_id: params.weblink,
            enable: false,
        });
    }

    return promisifyDeferredCall(api.weblinks.domestic.off, params);
};
